import { render, staticRenderFns } from "./SbgCabangV4.vue?vue&type=template&id=41f81c9f&scoped=true&"
import script from "./SbgCabangV4.vue?vue&type=script&lang=js&"
export * from "./SbgCabangV4.vue?vue&type=script&lang=js&"
import style0 from "./SbgCabangV4.vue?vue&type=style&index=0&id=41f81c9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f81c9f",
  null
  
)

export default component.exports